import Call from '../Call.v2';

const TrackerPartners = {
    get() {
        return Call(`trackerPartners`);
    }
};

export default TrackerPartners;



// WEBPACK FOOTER //
// ./src/services/API/components/TrackerPartners.js